import { render, staticRenderFns } from "./LoanReporting.vue?vue&type=template&id=877d8c28"
import script from "./LoanReporting.vue?vue&type=script&lang=js"
export * from "./LoanReporting.vue?vue&type=script&lang=js"
import style0 from "./LoanReporting.vue?vue&type=style&index=0&id=877d8c28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports